/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnUserGender } from './en-user-gender';
import { EnUserType } from './en-user-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface ProfileDto
 */
export interface ProfileDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ProfileDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ProfileDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ProfileDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ProfileDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof ProfileDto
     */
    firstName: string;

    /**
     * @type {string}
     * @memberof ProfileDto
     */
    lastName: string;

    /**
     * @type {string}
     * @memberof ProfileDto
     */
    fiscalCode: string;

    /**
     * @type {string}
     * @memberof ProfileDto
     */
    email: string;

    /**
     * @type {string}
     * @memberof ProfileDto
     */
    dateOfBirth?: string | null;

    /**
     * @type {number}
     * @memberof ProfileDto
     */
    height?: number | null;

    /**
     * @type {number}
     * @memberof ProfileDto
     */
    weight?: number | null;

    /**
     * @type {EnUserGender}
     * @memberof ProfileDto
     */
    gender?: EnUserGender | null;

    /**
     * @type {boolean}
     * @memberof ProfileDto
     */
    verified: boolean;

    /**
     * @type {JoinEntityDto}
     * @memberof ProfileDto
     */
    client: JoinEntityDto;

    /**
     * @type {EnUserType}
     * @memberof ProfileDto
     */
    type?: EnUserType;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof ProfileDto
     */
    authorities?: Array<JoinEntityDto>;

    /**
     * @type {string}
     * @memberof ProfileDto
     */
    note?: string | null;

    /**
     * Timestamp of member self-service account deletion — null when deleted by an admin or not deleted
     *
     * @type {string}
     * @memberof ProfileDto
     */
    selfDeletedAt: string | null;
}
